import { createMtListenerMiddleware } from "@/lib/storage/create-mt-listener-middleware"
import { itineraryApi } from "./api/itinerary-api"
import { populateTripCache } from "./api/trips-api"
import detailSheetSlice from "./detail-sheet-slice"
import { AppDispatch, RootState } from "./redux-store"
import tripSlice from "./trip-slice"

const itinerarySyncMiddleware = createMtListenerMiddleware<RootState>(
  "itinerary-sync-middleware"
)

// When events are removed via RTK Query, clear highlighted event if needed
itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.removeEvents.matchFulfilled,
  effect: (action, listenerApi) => {
    const { eventIds } = action.meta.arg.originalArgs
    const state = listenerApi.getState()

    // Clear highlighted event in trip-slice if it was removed
    if (
      state.tripSlice.highlightedEvent.id &&
      eventIds.includes(state.tripSlice.highlightedEvent.id)
    ) {
      listenerApi.dispatch(tripSlice.actions.clearHighlightedEvent())
    }

    // Clear itinerary event in detail-sheet-slice if it was removed
    if (
      state.detailSheetSlice.itineraryEvent &&
      eventIds.includes(state.detailSheetSlice.itineraryEvent.id)
    ) {
      listenerApi.dispatch(detailSheetSlice.actions.clearItineraryEvent())
    }
  },
})

// When events are removed via removeEventsWithPlace, clear highlighted event if needed
itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.removeEventsWithPlace.matchFulfilled,
  effect: (action, listenerApi) => {
    const { events } = action.payload
    if (!events || events.length === 0) return

    const eventIds = events.map((e) => e.id)
    const state = listenerApi.getState()

    // Clear highlighted event in trip-slice if it was removed
    if (
      state.tripSlice.highlightedEvent.id &&
      eventIds.includes(state.tripSlice.highlightedEvent.id)
    ) {
      listenerApi.dispatch(tripSlice.actions.clearHighlightedEvent())
    }

    // Clear itinerary event in detail-sheet-slice if it was removed
    if (
      state.detailSheetSlice.itineraryEvent &&
      eventIds.includes(state.detailSheetSlice.itineraryEvent.id)
    ) {
      listenerApi.dispatch(detailSheetSlice.actions.clearItineraryEvent())
    }
  },
})

// When itinerary is cleared, reset related state
itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.clearItinerary.matchFulfilled,
  effect: (_action, listenerApi) => {
    listenerApi.dispatch(tripSlice.actions.clearHighlightedEvent())
    listenerApi.dispatch(detailSheetSlice.actions.resetState())
  },
})

// Sync trip updates from itinerary mutations to RTK Query cache
itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.removeEvents.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.removeEventsWithPlace.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.insertDay.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.removeDay.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.undoItinerary.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.redoItinerary.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.createEvent.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

itinerarySyncMiddleware.startListening({
  matcher: itineraryApi.endpoints.updateEvent.matchFulfilled,
  effect: (action, listenerApi) => {
    const { trip } = action.payload
    if (trip) {
      void populateTripCache(listenerApi.dispatch as AppDispatch, trip)
    }
  },
})

export { itinerarySyncMiddleware }
